<script>
import AmsuScholarshipCard from "../../Cards/AmsuScholarshipCard.vue";
import _ from "lodash";
import moment from "moment/moment";

export default {
  name: "ParamAchievementSection",
  components: {AmsuScholarshipCard},

  props: {
    achievement: {
      type: Object,
      default: {},
    }
  },

  computed: {
    nameAchievement() {
      return this.achievement?.name;
    },

    typeAchievement() {
      return this.achievement?.prtf_achievement_type_name;
    },

    kindAchievement() {
      return this.achievement?.prtf_achievement_kind_name;
    },

    scoreUnit() {
      const achievement = this.achievement;

      if (_.isNil(achievement?.subunit)) return achievement?.unit?.score;
      return achievement?.subunit?.score;
    },

    nameUnit() {
      const achievement = this.achievement;

      if (!_.isNil(achievement?.subunit) && !_.isNil(achievement?.subunit)) return `${achievement?.unit?.name}/${achievement?.subunit?.name}`;
      if (_.isNil(achievement?.subunit)) return achievement?.unit?.name;
      return achievement?.subunit?.name;
    },

    dateAchievement() {
      return moment(this.achievement?.date_end)?.format('DD.MM.YYYY') || "";
    },
  },
}
</script>

<template>
  <v-card
    class="rounded-xl"
    elevation="0"
  >

    <v-card-title>
      Параметры достижения
    </v-card-title>

    <v-list class="py-0">

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-title class="font-weight-bold color-name-achievement d-flex text-wrap">
            {{nameAchievement}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Название
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-title class="d-flex text-wrap">
            {{typeAchievement}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Деятельность
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-title class="d-flex text-wrap">
            {{kindAchievement}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Вид
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-title class="d-flex text-wrap">
            {{nameUnit}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Критерий
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content class="py-0">
          <v-list-item-title>
            {{scoreUnit}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Баллы
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content class="py-0">
          <v-list-item-title>
            {{dateAchievement}}
          </v-list-item-title>

          <v-list-item-subtitle>
            Дата
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<style scoped>

</style>